import * as React from "react";

import {
  Loading,
  useJoinForm,
  useLoginForm,
  useOneTimePasswordUserExperienceFirstStepSendCode,
  useOneTimePasswordUserExperienceSecondStepVerifyCode,
} from "../../Common";

import {
  useMyBagLoadingState,
  useDeliveryDetailsUserExperience,
  useSuccessPresenter,
  useMyBagOutOfStockUserExperience,
  ReactCheckout2022Route,
  useReactCheckout2022Router,
} from "../providers";

export const AppLoading: React.FunctionComponent = () => {
  const { isLoading: isJoinFormLoading } = useJoinForm();
  const { isLoading: isLoginFormLoading } = useLoginForm();
  const { isLoading: isOneTimePasswordSendCodeLoading } =
    useOneTimePasswordUserExperienceFirstStepSendCode();
  const { isLoading: isOneTimePasswordVerifyCodeLoading } =
    useOneTimePasswordUserExperienceSecondStepVerifyCode();

  const { isLoading: isMyBagLoading } = useMyBagLoadingState();
  const { isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall } =
    useMyBagOutOfStockUserExperience();
  const {
    isLoading: deliveryDetailsUserExperience_isInTheMiddleOfLoadingSomething,
  } = useDeliveryDetailsUserExperience();
  const { isLoading: successIsLoading } = useSuccessPresenter();
  const { currentRoute } = useReactCheckout2022Router();
  const shouldUseDeliveryDetailsLoading =
    currentRoute === ReactCheckout2022Route.delivery_details;

  const isLoading = React.useMemo(() => {
    const deliveryDetailsIsLoading =
      shouldUseDeliveryDetailsLoading &&
      deliveryDetailsUserExperience_isInTheMiddleOfLoadingSomething;
    return (
      isJoinFormLoading ||
      isLoginFormLoading ||
      isOneTimePasswordSendCodeLoading ||
      isOneTimePasswordVerifyCodeLoading ||
      isMyBagLoading ||
      isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall ||
      deliveryDetailsIsLoading ||
      successIsLoading
    );
  }, [
    isJoinFormLoading,
    isLoginFormLoading,
    isOneTimePasswordSendCodeLoading,
    isOneTimePasswordVerifyCodeLoading,
    isMyBagLoading,
    isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall,
    deliveryDetailsUserExperience_isInTheMiddleOfLoadingSomething,
    shouldUseDeliveryDetailsLoading,
    successIsLoading,
  ]);

  if (!isLoading) {
    return null;
  }

  return <Loading />;
};
